import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../Tutorial/SectionChapter';
import SectionHeader from '../../Tutorial/SectionHeader';
import { FindMoreButton } from '../../Home/HomeFeatures/FindMoreButton';
import { tutorialLinks } from '../../../common/urlLinks';

const Geometry = ({ refs }) => {
    const paste = [
        {
            children: (
                <>
                    <ul>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="redesign.page.home.feature.geometry.description1" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="redesign.page.home.feature.geometry.description2" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="redesign.page.home.feature.geometry.description3" />
                            </Typography>
                        </li>
                    </ul>
                    <a href={tutorialLinks.geometry}>
                        <FindMoreButton />
                    </a>
                </>
            ),
        },
    ];
    return (
        <>
            <SectionHeader
                refs={refs}
                title={'redesign.page.home.feature.geometry.tag'}
                id={'section-geometry'}
                img={`/static/asset/img/features/instrumente_geometrie.png`}
            />
            <SectionChapter
                refs={refs}
                id={'section-geometry-section'}
                title={'redesign.page.home.feature.geometry.description'}
                explanations={paste}
            />
        </>
    );
};

export default Geometry;
